(function () {
  var links = Array.prototype.slice.call(document.querySelectorAll('.kk-cart-link'));
  if (!links.length) return;

  function syncFor(link, count) {
    var n = parseInt(count, 10) || 0;

    // Show only when there are items
    link.classList.toggle('is-hidden', n <= 0);

    // Update inline "(N)"
    var inline = link.querySelector('.cart-inline-count');
    if (inline) inline.textContent = n > 0 ? ' (' + n + ')' : '';

    // Update ARIA label for screen readers
    var base = link.getAttribute('data-label-cart') || 'Cart';
    link.setAttribute('aria-label', n > 0 ? base + ', ' + n + (n === 1 ? ' item' : ' items') : base);
  }

  links.forEach(function (link) {
    // Dawn updates this span on AJAX; we mirror its value
    var bubbleCount = link.querySelector('.cart-count-bubble [aria-hidden="true"]');

    if (bubbleCount) {
      syncFor(link, bubbleCount.textContent.trim());
      var obs = new MutationObserver(function () {
        syncFor(link, bubbleCount.textContent.trim());
      });
      obs.observe(bubbleCount, { childList: true, characterData: true, subtree: true });
    } else {
      // Fallback: read the cart once on load
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { syncFor(link, (d && d.item_count) || 0); })
        .catch(function () {});
    }
  });

  // Safety: refresh on common cart events
  function refreshAll() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        links.forEach(function (link) { syncFor(link, (d && d.item_count) || 0); });
      })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', refreshAll);
  document.addEventListener('cart:refresh', refreshAll);
  document.addEventListener('cart:change', refreshAll);
})();